import {useQuery} from "@tanstack/react-query";

import {residentClaimService} from "../services";

type UseResidentClaimVerifyParams = {
  token: string | undefined;
  enabled?: boolean;
};

export default function useResidentClaimVerify({
  token,
  enabled = true,
}: UseResidentClaimVerifyParams) {
  return useQuery({
    queryKey: ["resident-claim", "verify", token],
    queryFn: () => {
      if (!token) {
        return Promise.reject(new Error("Verification token is required"));
      }
      return residentClaimService.verifyClaim(token);
    },
    enabled: enabled && Boolean(token),
    retry: false,
  });
}
